"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyBase_1 = require("./WrappedPropertyBase");
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var functions_1 = require("./functions");
var WrappedPropertyString = /** @class */ (function (_super) {
    __extends(WrappedPropertyString, _super);
    function WrappedPropertyString(dest, parent, propName, schema, options) {
        var _this = _super.call(this, dest, parent, propName, schema, options) || this;
        // //export const wrapSchemaProps = ['maxLength', 'minLength', 'maxItems', 'minItems', 'minimum', 'maximum', 'exclusiveMaximum', 'exclusiveMinimum', 'precision'];
        functions_1.wrapSchemaProps(_this.$schema, _this._internal, 'number', ['maxLength', 'minLength', 'minimum', 'maximum', 'exclusiveMaximum', 'exclusiveMinimum']);
        functions_1.initVue(_this, _this._internal);
        return _this;
        // console.log('string created', propName, this._internal.vmUserData);
    }
    WrappedPropertyString.prototype.$validate = function (value) {
        if (value === undefined) {
            value = this.$model;
        }
        this.$dirty = true;
        var req = this.$schema.fieldRequired;
        // console.log('propName.get()', req, svalue);
        if (value === '' || value === null) {
            if (this.$schema.fieldRequired) {
                // console.timeEnd('(string)$validate');
                return functions_1.getRuleMessage(this._internal, 'required', value, this.$schema);
            }
            if (this.$schema.enum && this.$schema.enum.indexOf(value) === -1) {
                return functions_1.getRuleMessage(this._internal, 'enum', value, this.$schema);
            }
            return null;
        }
        // console.timeEnd('(string)$validate');
        return _super.prototype.$validate.call(this, value);
    };
    WrappedPropertyString.prototype.getValue = function () {
        var svalue = this.$model;
        // if ($schema.format === 'date-time' && typeof propName === 'number') {
        //  console.log('gettinf date-time', svalue, parent, JSON.stringify(propName));
        // }
        // let svalue = obj.$model;
        // to jest niepotrzebne, bo teraz czyta $error
        /*
        if (this.$dirty) {
          this.$validate(svalue);
        }
        */
        if (svalue !== null) {
            switch (this.$schema.format) {
                case 'date':
                    if (svalue && svalue.length >= 10) {
                        var nsvalue = svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                        svalue = nsvalue;
                    }
                    break;
                case 'date-time':
                    if (svalue && svalue.length >= 10) {
                        var nsvalue = svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                        if (svalue.length === 19) {
                            var ntvalue = svalue.substr(11, 8);
                            // if (ntvalue !== '00:00:00') {
                            nsvalue += ' ' + ntvalue;
                            // }
                        }
                        // console.log('get date-time', svalue, nsvalue, ntvalue);
                        svalue = nsvalue;
                    }
                    break;
            }
        }
        return svalue || '';
    };
    WrappedPropertyString.prototype.setValue = function (newValue) {
        /*
                if (newValue === '' || newValue === null) {
                  if ($schema.fieldRequired) {
                    vm.error = getRuleMessage(schema, 'required', newValue, $schema);
                    // console.log('empty required ' + propName, vm.error);
                    // ok = false;
                    typeok = false;
                  }
                  // newValue = '';
                }
                */
        // check save type
        if (newValue !== null) {
            if (this.$schema.format) {
                switch (this.$schema.format) {
                    case 'date':
                        if (newValue && newValue.length >= 10) {
                            newValue = newValue.substr(6, 4) + "-" + newValue.substr(3, 2) + "-" + newValue.substr(0, 2);
                            // console.log('set date-time', newValue);
                        }
                        break;
                    case 'date-time':
                        if (newValue && newValue.length >= 10) {
                            if (newValue.length === 19) {
                                newValue = newValue.substr(6, 4) + "-" + newValue.substr(3, 2) + "-" + newValue.substr(0, 2) + " " + newValue.substr(11);
                            }
                            else {
                                newValue = newValue.substr(6, 4) + "-" + newValue.substr(3, 2) + "-" + newValue.substr(0, 2) + " 00:00:00";
                            }
                            // console.log('set date-time', newValue);
                        }
                        break;
                }
            }
        }
        /*
                if (!typeok) {
                  this.stringValue = newValue;
                } else {
                  this.stringValue = null;
                }
                */
        // parent[propName] = newValue;
        this.$model = newValue;
        /*
        if (this.$schema.format === 'date-time') {
          // console.log('date parent', parent);
        }
        */
        if (!this.$dirty && this._options.dirtyOnInput) {
            this.$dirty = true;
        }
    };
    return WrappedPropertyString;
}(WrappedPropertyBase_1.default));
exports.default = WrappedPropertyString;
WrappedPropertyCtor_1.default.string = WrappedPropertyString;
//# sourceMappingURL=WrappedPropertyString.js.map